import { api } from '@services';

import Product, { IProduct, IProductApiModel } from '@models/Product.model';
import { IPaginationResult } from '@models/Equipment.model';

export interface IFilterRequest {
  modelNames?: string[];
  manufactorNames?: string[];
  sort?: string;
  /* searches product.name, product.model, last updated commit: 58aad444 */
  modelName?: string;
  /* searches only product.model last updated commit: 58aad444 */
  modelNumber?: string;
  direction?: 'ASC' | 'DESC' | undefined;
  filterByEquipment?: boolean;
  manufacturerId?: string;
}
export interface IPagination {
  page: number;
  limit: number;
  /* searches  product.model, product.name, product.customNames, manufacturer.name last updated commit: 58aad444 */

  search?: string;
}
interface IRequest {
  pagination?: IPagination;
  filter?: IFilterRequest;
}

const getProducts = async ({
  pagination,
  filter,
}: IRequest): Promise<IPaginationResult<IProduct>> => {
  const { data: products } = await api.get<IPaginationResult<IProductApiModel>>(
    `/products?page=${pagination?.page || 1}&limit=${pagination?.limit || 20}${
      pagination?.search ? `&q=${encodeURIComponent(pagination.search)}` : ''
    }${filter?.sort ? `&sort=${filter.sort}` : ''}${
      filter?.filterByEquipment ? `&filterByEquipment=true` : ''
    }${filter?.direction ? `&direction=${filter.direction}` : ''}${
      filter?.modelNames
        ? `&modelNames=${encodeURIComponent(filter.modelNames.join(','))}`
        : ''
    }${
      filter?.manufactorNames
        ? `&manufactorNames=${encodeURIComponent(
            filter.manufactorNames.join(','),
          )}`
        : ''
    }${
      filter?.modelName
        ? `&modelName=${encodeURIComponent(filter.modelName.toString())}`
        : ''
    }${
      filter?.modelNumber
        ? `&modelNumber=${encodeURIComponent(filter.modelNumber.toString())}`
        : ''
    }${
      filter?.manufacturerId
        ? `&manufacturerId=${encodeURIComponent(
            filter.manufacturerId.toString(),
          )}`
        : ''
    }
`,
  );

  return Product.arrayPaginatedFromApiModel(products);
};
export { getProducts };
